import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
var classNames = require("classnames");

import ReactTimeAgo from "react-time-ago";
import { NotificationManager } from "Components/ReactNotifications";
import { PopoverItem, TooltipItem } from "Components/PopoverTooltip";

import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";

import API from "../../api/index";
import { Row, Alert, Card, CardBody, Button, CardTitle, Modal, CustomInput, ModalBody, ModalHeader, ModalFooter, Input } from "reactstrap";

import Switch from "rc-switch";
import "rc-switch/assets/index.css";

import NumberFormat from "react-number-format";
import { Colxx, Separator } from "Components/CustomBootstrap";
import StateButton from "Components/StateButton";

import Select from "react-select";
import CustomSelectInput from "Components/CustomSelectInput";


class listPayments extends Component {
	constructor(props) {
		super(props);

		this.state = {
			SearchPhrase: "",
			isRefreshing: false,
			isLoading: true,
			orders: [],
      bankCards:[]
		};
		this.deleteOrderFromList = this.deleteOrderFromList.bind(this);
		this.deletingOrderFromList = this.deletingOrderFromList.bind(this);
		this.loadData = this.loadData.bind(this);
		this.loadData();
	}
	loadData(key) {
		API.order.lists.payment
			.get({})
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					orders: this.preprocessOrderData(data.orders),
					bankCards: this.preprocessOrderData(data.bankCards),
					isLoading: false,
					isRefreshing: false,
				});
			})
			.catch((error) => {});
	}
	preprocessOrderData(ordersData) {
		for (var i = 0; i < ordersData.length; i++) {
			ordersData[i].deleting = false;
		}
		return ordersData;
	}
	deleteOrderFromList(OrderId) {
		var tmpObj = this.state.orders;
		for (var i = 0; i < tmpObj.length; i++) {
			if (tmpObj[i].OrderId == OrderId) {
				tmpObj.splice(i, 1);
			}
		}
		this.setState({ orders: tmpObj });
	}
	deletingOrderFromList(OrderId) {
		var tmpObj = this.state.orders;
		for (var i = 0; i < tmpObj.length; i++) {
			if (tmpObj[i].OrderId == OrderId) {
				tmpObj[i].deleting = true;
			}
		}
		this.setState({ orders: tmpObj });
		setTimeout(() => {
			this.deleteOrderFromList(OrderId);
		}, 2000);
	}

	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className="mb-4">
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<CardTitle>
									<div className={"iconsminds-financial headingicon"} />
									صف سفارش‌های منتظر پرداخت
									<Button
										className={"default mb-1"}
										outline
										color={"info"}
										style={{ float: "left", border: "unset", width: "40px", borderRadius: 50, padding: "10px" }}
										onClick={() => {
											this.setState({ isRefreshing: true });
											this.loadData();
										}}
									>
										<div className={" simple-icon-reload tableheadingicon"} />
									</Button>
									<div style={{ width: 200, float: "left", display: "inline-block", marginLeft: "10px", borderRadius: 50 }}>
										<Input
											autoComplete="off"
											type="text"
											name="SearchPhrase"
											id="SearchPhrase"
											color="info"
											placeholder=""
											value={this.state.SearchPhrase}
											onChange={(e) => {
												this.setState({ SearchPhrase: e.target.value });
											}}
											style={{ borderRadius: "50px", padding: "9px", lineHeight: "29px", paddingBottom: "5px", paddingTop: "7px", paddingLeft: "35px", paddingRight: "19px" }}
										/>
										<Button
											style={{
												position: "absolute",
												top: 22,
												marginRight: "165px",
												marginTop: "11px",
												fontSize: 20,
												padding: "5px",
												color: "lightgray",
												backgroundColor: "transparent",
												border: "unset",
												display: this.state.SearchPhrase != "" ? "block" : "none",
											}}
											onClick={(e) => {
												this.setState({ SearchPhrase: "" });
											}}
										>
											<i className="simple-icon-close"></i>
										</Button>
									</div>
								</CardTitle>
								{!this.state.isRefreshing ? (
									<div className="table-responsive">
										<table className="table table-hover order-table">
											<thead>
												<tr>
													<th>شماره سفارش</th>
													<th>
														<div className={" iconsminds-down arrowsorticon"} />
														زمان ثبت
													</th>
													<th>موبایل</th>
													<th>نام مشتری </th>
													<th>مبلغ سفارش </th>
													<th>نوع سفارش</th>

													<th>تکمیل اطلاعات</th>
													<th>
														<a title="لینک ارسالی به کاربر" className={" simple-icon-link tableheadingicon"} />
													</th>

													<th>
														<a title="تعداد کل بازدید ها از لینک کاربر" className={" simple-icon-eye tableheadingicon"} />
													</th>
													<th>
														<a title="سفارش آدرس دارد؟" className={" simple-icon-location-pin tableheadingicon"} />
													</th>
													<th>
														<a title="آیا کاربر در لینک نوع پرداخت را کلیک کرده؟" className={" iconsminds-arrow-back-3 tableheadingicon"} />
													</th>
													<th>
														<a title="آیا سفارش تحویل حضوری است؟" className={" iconsminds-shop-2 tableheadingicon"} />
													</th>
													<th>اپراتور</th>
													<th>عملیات</th>
												</tr>
											</thead>
											{this.state.orders
												.filter((row) => {
													return this.state.SearchPhrase.trim() == ""
														? true
														: row.CustomerMobile.indexOf(this.state.SearchPhrase) > -1 ||
																(row.OrderId + "").indexOf(this.state.SearchPhrase) > -1 ||
																row.CustomerFullName.indexOf(this.state.SearchPhrase) > -1 ||
																row.Payable.indexOf(this.state.SearchPhrase) > -1 ||
																row.OrderType.indexOf(this.state.SearchPhrase) > -1 ||
																row.OperatorName.indexOf(this.state.SearchPhrase) > -1;
												})
												.map((row) => (
                         
                          <TableBodyRows key={row.OrderId}  data={row}  deletingOrderFromList={this.deletingOrderFromList}  bankCards={this.state.bankCards}/>
													// <TableBodyRows key={row.OrderId} data={row} deletingOrderFromList={this.deletingOrderFromList} />
												))}
										</table>
									</div>
								) : (
									<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
								)}
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TableBodyRows extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			clicked: false,
			NotePayment: "",
			DoPrints: true,
			BankCardID: -1,
		};
		this.toggle = this.toggle.bind(this);
		this.handlePaymentButtonClick = this.handlePaymentButtonClick.bind(this);
		this.handleCancleButtonClick = this.handleCancleButtonClick.bind(this);
		this.handleBankCardSelection = this.handleBankCardSelection.bind(this);
    this.generateBankCardSelectData = this.generateBankCardSelectData.bind(this);
	}
  generateBankCardSelectData(BankCardsSort) {
    // Start with the option for 'Other Cards'
    // const selectData = [{ label: "سایر کارت‌ها", value: -1, key: -1 }];
	const selectData = [];

    // Loop through the array of BankCardsSort IDs
    BankCardsSort.forEach((id, index) => {
      // Find the bank card item in this.props.bankCards with a matching id
      const bankCard = Object.values(this.props.bankCards).find(card => card.id === id);
    
      if (bankCard) {
        // Construct the label using bank card details
        const label = `${bankCard.bankName} - ${bankCard.name} ${bankCard.surname} - ${bankCard.cardNumber.slice(-4)}`;
        
        // Push the new option into the selectData array
        selectData.push({
          label: label,
          value: id,
          key: index
        });
      }
    });
  
    return selectData;
  };
  
	handleBankCardSelection = (selectedOption) => {
		this.setState({
			selectedOption,
			BankCardID: selectedOption.value,
		});
	};
	handlePaymentButtonClick(PaymentType) {
		return new Promise((success, fail, $this) => {
			this.setState({ clicked: true });

			API.order.lists.payment
				.record({ OrderId: this.props.data.OrderId, PaymentType: PaymentType, NotePayment: this.state.NotePayment, DoPrints: this.state.DoPrints,BankCardID:this.state.BankCardID })
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در ثبت پرداخت");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ثبت پرداخت", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
							this.setState({
								clicked: false,
							});
						}
					} else {
						success("پرداخت ثبت شد");
						setTimeout(() => {
							this.props.deletingOrderFromList(this.props.data.OrderId);
							this.setState({ clicked: false, modal: false });
						}, 1000);
					}
				})
				.catch((error) => {
					fail("خطا در ثبت پرداخت");
				});
		});
	}

	handleCancleButtonClick() {
		return new Promise((success, fail, $this) => {
			if (confirm("آیا از کنسل کردن این سفارش اطمینان کامل دارید؟")) {
				this.setState({ clicked: true });

				API.order
					.cancle({ OrderId: this.props.data.OrderId })
					.then((data) => {
						data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

						if (data.ERRORS !== undefined) {
							fail("خطا در ثبت کنسلی");
							for (var i = 0; i < data.ERRORS.length; i++) {
								setTimeout(
									function (err) {
										NotificationManager.error(err, "خطا در ثبت کنسلی", 8000, null, null, "filled");
									},
									(i + 1) * 700,
									data.ERRORS[i]
								);
								this.setState({
									clicked: false,
								});
							}
						} else {
							success("کنسلی ثبت شد");
							setTimeout(() => {
								this.props.deletingOrderFromList(this.props.data.OrderId);
								this.setState({ clicked: false, modal: false });
							}, 1000);
						}
					})
					.catch((error) => {
						fail("خطا در ثبت کنسلی");
					});
			} else {
				fail("خطا در ثبت کنسلی");
			}
		});
	}

	toggle() {
		if (this.state.clicked) {
			return;
		}
		this.setState({
			modal: !this.state.modal,
		});
	}
	render() {
		const {
			data: { OrderId, OpenedAt, CustomerMobile, CustomerFullName, Payable, OrderType, CustomerDataAccessEnable, HasAddress, DeliveryInPerson, CustomerPaymentSelection, CustomerDataAccessCode, CustomerDataLinkVisit, OperatorName, deleting,BankCardsSort },
		} = this.props;
		var OrderTypesFa = { SHOP: "حضوری", SITE: "سایت", CHAT: "چت" };
		var deletingClass = deleting ? " deleting-row " : "";
		var AlertAddress = false;
		if (OrderType == "CHAT" || OrderType == "SITE") {
			if (!DeliveryInPerson) {
				if (!HasAddress) {
					AlertAddress = true;
				}
			}
		}
		return (
			<tbody className={deletingClass}>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					<td>
						<a href={"/app/orders/view-order/" + OrderId} target="_blank">
							{" "}
							{OrderId} <div className={" simple-icon-arrow-left-circle icongotoorder"} />
						</a>
					</td>
					<td className={"text-muted"}>
						<ReactTimeAgo date={Date.parse(OpenedAt)} timeStyle="twitter" locale="en" />
					</td>

					<td>
						<a href={"/app/customers/view-customer/" + CustomerMobile} target="_blank">
							{" "}
							{CustomerMobile} <div className={" simple-icon-arrow-left-circle icongotoorder"} />
						</a>
					</td>
					<td>
						<div
							className={classNames({
								"text-muted": true,
								"simple-icon-options": CustomerFullName.trim() == "",
							})}
						/>
						{CustomerFullName}
					</td>
					<td className={"text-muted"}>
						<NumberFormat style={{ textAlign: "center" }} value={Payable} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>
					<td className={"text-muted"}>{OrderTypesFa[OrderType]}</td>
					<td className={"text-muted"}>
						<div
							className={classNames({
								"simple-icon-check": CustomerDataAccessEnable != 1,
								"simple-icon-options": CustomerDataAccessEnable == 1,
								"text-muted": true,
							})}
						/>
					</td>

					<td className={"text-muted"}>
						<a className={"text-muted"} href={"https://cust.akschap.com/app/order/take/" + CustomerDataAccessCode} target="_blank">
							لینک
						</a>
					</td>
					<td className={"text-muted"}>{CustomerDataLinkVisit}</td>
					<td>
						<div
							className={classNames({
								"simple-icon-check": HasAddress === true,
								"simple-icon-options": HasAddress === false,
								"text-muted": true,
							})}
						/>
					</td>
					<td className={"text-muted"}>
						{classNames({
							کارت: CustomerPaymentSelection == "other",
							درگاه: CustomerPaymentSelection == "site",
						})}
						<div
							className={classNames({
								"simple-icon-options": CustomerPaymentSelection != "site" && CustomerPaymentSelection != "other",
							})}
						/>
					</td>
					<td>
						<div
							className={classNames({
								"simple-icon-check": DeliveryInPerson === true,
								"simple-icon-options": DeliveryInPerson === false,
								"text-muted": true,
							})}
						/>
					</td>
					<td className={"text-muted"}>{OperatorName}</td>
					<td className={"text-muted"}>
						<Button
							className={"default md-2"}
							outline
							color={"info"}
							disabled={deleting}
							onClick={() => {
								this.setState({ modal: true });
							}}
						>
							ثبت پرداخت
						</Button>
						<Modal isOpen={this.state.modal} toggle={this.toggle}>
							<ModalHeader toggle={this.toggle}>ثبت پرداخت برای سفارش #{OrderId}</ModalHeader>
							<ModalBody>
								<table style={{ width: "100%" }}>
									<tbody>
										<tr>
											<th>شماره سفارش:</th>
											<td>{OrderId}</td>
										</tr>
										<tr>
											<th>موبایل مشتری:</th>
											<td>{CustomerMobile}</td>
										</tr>
										<tr>
											<th>نام مشتری:</th>
											<td>{CustomerFullName}</td>
										</tr>
										<tr>
											<th>مبلغ سفارش:</th>
											<td>
												<NumberFormat style={{ textAlign: "center" }} value={Payable} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
											</td>
										</tr>
										<tr>
											<th>توضیحات پرداخت:</th>
											<td>
												<textarea
													rows="3"
													disabled={this.state.clicked}
													onChange={(e) => {
														this.setState({ NotePayment: e.target.value });
													}}
													style={{ width: "100%" }}
												/>
											</td>
										</tr>
										<tr>
											<th>وضعیت ثبت پرداخت:</th>
											<td>
												<span
													className={classNames({
														"iconsminds-shop-2": DeliveryInPerson === true,
													})}
												/>
												&nbsp;
												{classNames({
													"دریافت حضوری": DeliveryInPerson === true,
												})}
												&nbsp; &nbsp;
												<span
													className={classNames({
														"simple-icon-location-pin": HasAddress === true,
													})}
												/>
												&nbsp;
												{classNames({
													"آدرس دارد": HasAddress === true,
												})}
											</td>
										</tr>

										<tr>
											<th>پرینت فاکتور:</th>
											<td>
												<Switch
													className="custom-switch custom-switch-primary"
													checked={this.state.DoPrints}
													onChange={(DoPrints) => {
														this.setState({ DoPrints });
													}}
													style={{
														display: "inline-block",
														marginLeft: "12px",
													}}
												/>
												{this.state.DoPrints ? "پرینت شود" : "پرینت نشود"}
											</td>
										</tr>
										<tr>
											<th>کارت بانکی:</th>
											<td></td>
										</tr>
										<tr>
											<td colSpan={2}>
												<Select
													components={{ Input: CustomSelectInput }}
													className="react-select"
													classNamePrefix="react-select"
													name="form-field-name"
													value={this.state.selectedOption}
													onChange={this.handleBankCardSelection}
													options={this.generateBankCardSelectData(BankCardsSort)} // Call the function to generate options
													placeholder="انتخاب کنید..."
												/>
											</td>
										</tr>
										{this.state.BankCardID !== -1 && (
											<tr>
												<td colSpan={2}>
													<table className="bank-card-info">
														<tbody>
															<tr>
																<td className="heading">نام بانک:</td>
																<td className="content">
																	<strong>{Object.values(this.props.bankCards).find(card => card.id === this.state.BankCardID).bankName}</strong>
																</td>
															</tr>
															<tr>
																<td className="heading">نام صاحب کارت:</td>
																<td className="content">
																	<strong>
																		{Object.values(this.props.bankCards).find(card => card.id === this.state.BankCardID).name} {Object.values(this.props.bankCards).find(card => card.id === this.state.BankCardID).surname}
																	</strong>
																</td>
															</tr>
															<tr>
																<td className="heading">شماره کارت:</td>
																<td className="content">
																	<strong>{Object.values(this.props.bankCards).find(card => card.id === this.state.BankCardID).cardNumber}</strong>
																</td>
															</tr>
															<tr>
																<td className="heading">شماره شبا:</td>
																<td className="content">
																	<strong>{Object.values(this.props.bankCards).find(card => card.id === this.state.BankCardID).shebaNumber}</strong>
																</td>
															</tr>
														</tbody>
													</table>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</ModalBody>
							<ModalFooter>
								{!AlertAddress ? (
									<div>
										{OrderType == "SITE" ? (
											<StateButton disabled={this.state.clicked} id="siteButton" orderId={OrderId} color="primary" className="mb-3 default" onClick={() => this.handlePaymentButtonClick("SITE")}>
												درگاه
											</StateButton>
										) : (
											<span />
										)}
										&nbsp;
										{((OrderType == "CHAT" || OrderType == "SITE") && DeliveryInPerson) || OrderType == "SHOP" ? (
											<StateButton disabled={this.state.clicked} id="cashButton" orderId={OrderId} color="primary" className="mb-3 default" onClick={() => this.handlePaymentButtonClick("CASH")}>
												نقد
											</StateButton>
										) : (
											<span />
										)}
										&nbsp;
										{((OrderType == "CHAT" ) && DeliveryInPerson) || OrderType == "SHOP" ? (
											<StateButton disabled={this.state.clicked} id="posButton" orderId={OrderId} color="primary" className="mb-3 default" onClick={() => this.handlePaymentButtonClick("POS")}>
												پوز
											</StateButton>
										) : (
											<span />
										)}
										&nbsp;
										{OrderType == "CHAT" || OrderType == "SHOP" ? (
											<StateButton disabled={this.state.BankCardID == -1} id="cardButton" orderId={OrderId} color="primary" className="mb-3 default" onClick={() => this.handlePaymentButtonClick("CARD")}>
												ثبت کارت
											</StateButton>
										) : (
											<span />
										)}
										&nbsp;
									</div>
								) : (
									<Alert color="danger" className="">
										<span className={" simple-icon-location-pin"} /> &nbsp; برای این سفارش آدرسی ثبت نشده است
									</Alert>
								)}
								<StateButton disabled={this.state.clicked} id="cancleButton" orderId={OrderId} color="danger" className="mb-3 default" onClick={() => this.handleCancleButtonClick("CARD")}>
									کنسل شد
								</StateButton>
							</ModalFooter>
						</Modal>
					</td>
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(listPayments));

// export default injectIntl(listPayments);
